import React, { Component } from 'react';

import EssentialIcon from '../../../../../common/icons/EssentialIcon';

import './StepCustomIcon.css';

export default class StepCustomIcon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false
    };
  }

  onClick = e => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  render() {
    return (
      <div className={'StepCustomIcon' + (this.props.disabled ? ' disabled' :'' ) + (this.props.selected ? ' selected' : '')} onClick={this.onClick}>
        <div className="circle">{this.props.data}</div>
        <div style={{ display: 'flex' }}>
          <EssentialIcon type={this.props.type} style={{ fontSize: '1.2rem', paddingRight: '5px' }} />
          <span className="below" style={{ lineHeight: '0.8rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '0.8rem' }}>
            {this.props.title}
          </span>
        </div>
      </div>
    );
  }
}
